/* import __COLOCATED_TEMPLATE__ from './trend-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import {
  type TrendingTopic,
  TrendingTopicTimeTrend,
} from 'embercom/components/reporting/automation/fin-ai-agent/analyze/topic-trends/trending-topics-data-resources';

interface Args {
  trendingTopic: TrendingTopic;
}

export default class TrendStamp extends Component<Args> {
  @service declare intl: IntlService;

  get timeTrend() {
    return this.args.trendingTopic.timeTrend;
  }

  get trendLabel() {
    let trend = [
      TrendingTopicTimeTrend.IncreasingTrend,
      TrendingTopicTimeTrend.DecreasingTrend,
      TrendingTopicTimeTrend.Flat,
    ];

    let anomaly = TrendingTopicTimeTrend.SingleWeekAnomaly;

    if (trend.includes(this.timeTrend)) {
      return this.intl.t(
        `components.reporting.automation.fin-insights.analyse.topic-trends.trend-stamp.trend`,
      );
    } else if (this.timeTrend === anomaly) {
      return this.intl.t(
        `components.reporting.automation.fin-insights.analyse.topic-trends.trend-stamp.anomaly`,
      );
    }

    return this.intl.t(
      'components.reporting.automation.fin-insights.analyse.topic-trends.trend-stamp.trend',
    );
  }

  get trendStampIcon() {
    if (
      this.trendLabel ===
      this.intl.t(
        'components.reporting.automation.fin-insights.analyse.topic-trends.trend-stamp.trend',
      )
    ) {
      return 'line-chart';
    } else {
      return 'active';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TrendStamp': typeof TrendStamp;
  }
}
